/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import { Typography } from "@mui/material";
import React from "react";

const Membership_Agreement = (props) => {
  return (
    <div>
      <Typography sx={termstextBold} gutterBottom>
        Membership Agreement
      </Typography>
      <Typography sx={termstext} paragraph>
        This Agreement ("Agreement") is entered into between the undersigned corporation, hereinafter
        referred to as "Member," and BXI WORLD LLP, hereinafter referred to as "BXI," for the purpose of
        establishing a membership account with BXI for trading products and services within the BXI
        Marketplace network. Member agrees to the following terms and conditions as a Member of BXI:
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        1. Offer of Products and Services
      </Typography>
      <Typography sx={termstext} paragraph>
        Member agrees to offer their products and services to
        other BXI Members on the Marketplace platform at their regular prevailing prices,
        providing the same warranties, guarantees, and level of service as offered to regular cash
        customers.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        2. Membership Fees
      </Typography>
      <Typography sx={termstext} paragraph>
        Members shall pay the appropriate membership fee as per the selected
        membership type Standard Membership or Advance Membership.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        3. BXI Success Fees
      </Typography>
      <Typography sx={termstext} paragraph>
        Member agrees to pay BXI a success fee, calculated at a rate of 12% for
        Standard members and 8% for Advanced members, based on the total amount of each
        trade purchased from other BXI Members on the Marketplace platform.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        4. Trade Credits and Credit Line Policies
      </Typography>
      <Typography sx={termstext} paragraph>
        Member acknowledges, consent, and grants BXI the
        right and authority to regulate and control the transaction within the exchange system, as
        well as administer Trade Limit policies for Members as stipulated in this Agreement.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        5. Voluntary Trades and Transactions
      </Typography>
      <Typography sx={termstext} paragraph>
        Member understands and agrees that all trades and
        transactions between Members on the Marketplace platform are voluntary and based on
        mutual agreement.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        6. Responsibility for Trades and Disputes
      </Typography>
      <Typography sx={termstext} paragraph>
        BXI assumes no responsibility for the quality, timely
        delivery, warranty, or any disputes arising between BXI Members regarding the traded
        products or services. Member acknowledges that BXI operates in a brokerage capacity
        and, therefore, agrees to indemnify and hold BXI harmless from any claims, debts,
        reasonable attorney fees, or liabilities arising from trade transactions, whether Member is
        a buyer or a seller.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        7. Modification of Agreement
      </Typography>
      <Typography sx={termstext} paragraph>
        BXI may, at its sole discretion, modify, amend, or change this
        Agreement as deemed necessary, provided the changes and policies are reasonably
        uniform among Members.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        8. Trade Rules and Regulations
      </Typography>
      <Typography sx={termstext} paragraph>
        The Member agrees to abide by and adhere to the "Trade
        Rules and Regulations" attached hereto, which form an integral part of this Agreement.
      </Typography>

      <Typography sx={termstextBold} gutterBottom>
        9. Entire Agreement
      </Typography>
      <Typography sx={termstext} paragraph>
        This Agreement, along with the attached "Trade Rules and
        Regulations," constitutes the entire agreement between Member and BXI World LLP and
        shall be binding upon Member, as well as their heirs, successors, personal representatives,
        and assigns.
      </Typography>

      <Typography sx={termstext} paragraph>
        Member acknowledges that this Agreement becomes effective upon being signed or agreed by
        Member and approved by an authorized representative of BXI.
      </Typography>
      <Typography sx={termstext} paragraph>
        IN WITNESS WHEREOF, Member and BXI have executed this Agreement as of
        the date mentioned in this Membership Agreement.
      </Typography>


      <Typography sx={{
        fontSize: "16px",
        fontFamily: "Poppins",
        textAlign: "center",
        mt: "50px"

      }}>THE RULES AND REGULATIONS OF TRADING</Typography>


      <Typography sx={termstext} paragraph>Hello Member, BXI requests you to read the Rules and Regulations of Trading carefully to avoid
        hurdles and difficulties while trading on the BXI Marketplace.</Typography>

      <Typography sx={termstext} paragraph>I, a member of BXI, fully aware and accept the following Rules and Regulations of Trading.</Typography>

      <Typography sx={termstext} paragraph>1. That BXI is a fintech company that also acts as a third-party record keeper of barter transactions
        among its members, who are business owners and professionals who contract with BXI to organize
        and facilitate the barter of their goods and services with each other.</Typography>

      <Typography sx={termstext} paragraph>2. That member has registered its company on the BXI Marketplace to exchange goods and/or
        services with other Members via the BXI Marketplace only.</Typography>

      <Typography sx={termstext} paragraph>3. That there are 2 types of Memberships i.e Standard Membership and Advanced Membership.
        Members have to choose a Membership plan to proceed ahead among (two) i.e., Advanced
        Membership of INR 25,000/- and Standard Membership of INR 5,000/-</Typography>

      <Typography sx={termstext} paragraph>4. That member must conduct trade only and only on the barter system and use of cash is strictly
        prohibited except for payment of the following:</Typography>

      <Typography sx={{ ...termstext, fontWeight: "bold" }} paragraph>a. GST and other applicable taxes</Typography>
      <Typography sx={{ ...termstext, fontWeight: "bold" }} paragraph>b. BXI Commission</Typography>
      <Typography sx={{ ...termstext, fontWeight: "bold" }} paragraph>c. Delivery Charges</Typography>

      <Typography sx={termstext} paragraph>5. That Member shall abide by applicable GST, local laws, and regulations appropriate to any trade,
        and BXI is not responsible for any failure on the part of the member to comply. Under no
        circumstances will BXI be responsible for paying GST, any other taxes, or any other charges on behalf
        of any Member.</Typography>

      <Typography sx={termstext} paragraph>6. That a “trade” is a barter purchase or sale of goods and/or services on the BXI Marketplace
        whereby payment is made in Trade Credits. Trade Credits is an accounting unit used to record the
        value of trades. Ownership of Trade Credits denotes the right to receive goods and services available
        within the BXI Marketplace.</Typography>

      <Typography sx={termstext} paragraph>
        7. That 1 Trade Credits is equal to 1 INR but it is not currency. Trade Credits which are not currency
        are issued by BXI to its members against Products. Trade Credits are used for trading purposes only
        and cannot be transferred between Members without a Transaction. Trade Credits cannot be
        purchased for INR. Trade Credits are not Legal Tender of the Republic of India and are interest-free.
      </Typography>

      <Typography sx={termstext} paragraph>8. That Member can apply for Trade Limit which is granted to the Member against the Products
        and/or Services uploaded for sale on the Marketplace. The Member holds the discretion to select
        specific Products or Services and offer them as backing to BXI to secure a Trade Limit in the form of
        Trade Credits. BXI shall evaluate the products/services by their quality, quantity, offered rate, and
        demand for the products/services based on inspection BXI issues Trade Limit. Once the Products and
        Services are pledged to BXI for the Trade Limit, they cannot be withdrawn or delisted from the
        Marketplace. It is obligatory for the Member to ensure that the pledged Products and Services
        remain listed for sale on the Marketplace and are delivered in optimal condition and at the agreed
        price, in accordance with the same terms and conditions under which they were pledged.</Typography>

      <Typography sx={termstext} paragraph>9. That the products offered in exchange for Trade Limit shall be made available and should be in
        good condition as provided during the time of sampling for Trade Limit to the BXI procurement team.</Typography>

      <Typography sx={termstext} paragraph>10. That responsibility for the conduct of the trade is exclusive of the two members participating in
        the trade. Member acknowledges that the sole principal in any trade is the buying and selling
        members involved, that trades are entered into voluntarily, and that BXI is not the agent of any
        Member, nor is it the guarantor of any trade or Trade Credits.</Typography>

      <Typography sx={termstext} paragraph>11. That BXI is committed to provide only those products/services that may be available in the
        exchange system at any given time. BXI is not responsible if a member cannot find specific
        products/services to buy from other Members.</Typography>

      <Typography sx={termstext} paragraph>12. That Member is obligated to sell their products/services on the marketplace at their normal,
        customary rates that they typically sell their products/services for in a case environment. Violations
        may result in the Termination of the Member’s account and/or immediate adjustment of the
        transactions involved. Also, requisite legal actions shall be commenced against the wrongdoer.</Typography>


      <Typography sx={termstext} paragraph>Member is fully aware that if a member violates any terms or hereafter in effect, BXI may
        immediately terminate its account in accordance with these Rules or may freeze all activity in an
        account without notice until such time as BXI in its sole discretion, reinstates the Member or decides
        to terminate Member’s account. Member acknowledges that the decision of BXI to freeze and/or
        terminate Member’s account shall be final, binding, and conclusive.</Typography>

      <Typography sx={termstext} paragraph>
        Date: {props.Date}
      </Typography>
      <Typography sx={termstext} paragraph>
        Time: {props.Time}
      </Typography>
      <Typography sx={termstext} paragraph>
        Place: {props.Place}
      </Typography>
    </div>
  );
};

export default Membership_Agreement;

const termstext = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: {
    xl: "14px",
    lg: "14px",
    md: "13px",
    sm: "8px",
    xs: "8px",
  },
  lineHeight: "20px",
  textAlign: "justify",
  color: "#7D8BA6",
};

const termstextBold = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: {
    xl: "15px",
    lg: "15px",
    md: "13px",
    sm: "8px",
    xs: "8px",
  },
  lineHeight: "20px",
  textAlign: "justify",
  color: "#000",
};
